<entity-import-validation-summary [importFileModel]="importFileModel"></entity-import-validation-summary>

@if (importFileModel) {
    <entity-import-editor
        [importFileModel]="importFileModel"
        [selectedRowsInfo$]="selectedRowsInfo$"
        [busyRefId]="busyRefId">
    </entity-import-editor>
}
